import styled, { css } from 'styled-components';

export const Image = styled.div<{
  imageUrl: string;
  isPlaceholder: boolean;
  isSelected?: boolean;
  isLoading?: boolean;
}>`
  background-color: ${props => {
    if (props.isSelected && !props.isPlaceholder) {
      return 'transparent';
    }
    if (!props.isPlaceholder) return 'inherit';
    return props.isSelected ? '#CCCCCC' : '#666666';
  }};
  background-image: ${({ imageUrl, isPlaceholder }) => (isPlaceholder ? 'none' : `url(${imageUrl})`)};
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 97px;
  max-height: 97px;
  aspect-ratio: 4 / 3;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  opacity: ${props => (props.isLoading || props.isFailed ? '0.7' : 1)};
  border: ${props => (props.isFailed ? '1px solid #D01C2E' : 'none')};

  @media (orientation: landscape) {
    border: ${props => (props.isFailed ? '2px solid #D01C2E' : '2px solid #999999')};
    min-height: 92px;
    max-height: 92px;
  }

  ${({ isSelected, isPlaceholder }) =>
    isSelected &&
    !isPlaceholder &&
    css`
      filter: grayscale(0.7);
    `}
`;

export const PlaceholderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

export const PlaceholderWrapper = styled.div<{ withLabel?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: ${props => (props.withLabel ? '75%' : '100%')};

  color: white;
`;
